import React from "react";

import {
  Button,
  Container,
  Image,
  SimpleGrid,
  Text,
  Title,
} from "@mantine/core";

import { AppName, NotFound404Image } from "../../Lib/Data";

import "./styles.scss";
import { Link } from "react-router-dom";

const NotFound404: React.FC = () => {
  document.title = `Unrecognized Resource Request | ${AppName}`;

  return (
    <div className="not-found-container">
      <Container className={"root"}>
        <SimpleGrid spacing={{ base: 40, sm: 80 }} cols={{ base: 1, sm: 2 }}>
          <Image src={NotFound404Image} className={"mobileImage"} />
          <div>
            <Title className={"title"}>Something is not right...</Title>
            <Text c="dimmed" size="lg">
              The page you're looking for doesn't exist. It may have been moved,
              deleted, or you may have mistyped the address. If you believe this
              is an error, please contact support and we'll be happy to assist
              you.
            </Text>
            <Link to="/">
              <Button variant="outline" size="md" mt="xl" className={"control"}>
                Get back to home page
              </Button>
            </Link>
          </div>
          <Image src={NotFound404Image} className={"desktopImage"} />
        </SimpleGrid>
      </Container>
    </div>
  );
};
export default NotFound404;
